export enum Navigation {
  "MapView" = "MapView",
  "VideoView" = "VideoView",
  "GridView" = "GridView",
}

